var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "createStudentNotify",
          attrs: {
            "label-width": "140px",
            model: _vm.createStudentNotify,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Nội dung:", prop: "sendContent" } },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            rows: 7,
                            type: "textarea",
                            placeholder: "Nhập nội dung...",
                          },
                          model: {
                            value: _vm.createStudentNotify.sendContent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.createStudentNotify,
                                "sendContent",
                                $$v
                              )
                            },
                            expression: "createStudentNotify.sendContent",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tab-info-button" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("createStudentNotify")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Gửi")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: { click: _vm.closeForm },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }